const search = (() => {

    const initBlock = (el) => {
        
        const form = el.querySelector('[data-search-form]');
        const input = el.querySelector("[data-input]")
        const formSearchTermInput = form.querySelector('input[name="searchTerm"]');
        const formPageInput = form.querySelector('input[name="page"]');
        const formCategoryInput = form.querySelector('input[name="category"]');
        
        el.querySelectorAll('[data-category]').forEach(category => {
            category.addEventListener('click', () => {
                formCategoryInput.value = category.dataset.category;
                form.submit();
            });
        });
        
        const prevButton = el.querySelector('[data-prev]');
        if (prevButton){
            prevButton.addEventListener('click', () => {
                formPageInput.value = prevButton.dataset.prev;
                form.submit();
            });
        }

        const nextButton = el.querySelector('[data-next]');
        if (nextButton){
            nextButton.addEventListener('click', () => {
                formPageInput.value = nextButton.dataset.next;
                form.submit();
            });
        }
        
        const pageSelect = el.querySelector('[data-page-select]');
        if (pageSelect){
            pageSelect.addEventListener('change', () => {
                formPageInput.value = pageSelect.value;
                form.submit();
            });
        }
        
    };

    return {initBlock};
})();

document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('[data-search]').forEach(item => search.initBlock(item));
});